<div style="display: flex; flex-flow: column nowrap; gap: 40px">

	<div style="font-size: 22px; color: var(--mainColor)">
		Möchten Sie den Benutzer wirklich abmelden?
	</div>

	<div style="display: flex; flex-flow: row wrap; gap: 2em; justify-content: center;">

		<button
			mat-raised-button
			color="warn"
			(click)="dialogRef.close(true)"
		>
			Ja
		</button>

		<button
			mat-raised-button
			(click)="dialogRef.close(false)"
		>
			Nein
		</button>

	</div>

</div>